import { render, staticRenderFns } from "./OrganizationViewModal.vue?vue&type=template&id=36b12c88&"
import script from "./OrganizationViewModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports